module.exports = __webpack_public_path__ + "img/A3.2655e26b.svg";